import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import CardSection from 'components/sales/cardSection/cardSection';
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import {toast} from "react-toastify";
import ConfirmationItration from './confirmationItration';

const PrConfirmation = ({
  match,
  history,
  getServiceRequestedQty,
  servicesQty,
  saveServiceQuanity,
  getServiceQuantityConfirmation,
  servicesQtyConfirmation
}) => {

  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [prNo, setPrNo] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [inputList, setInputList] = useState([]);
  const [bgColor, setBgColor] = useState('');
  //console.log('servicesQtyConfirmation ' + JSON.stringify(servicesQtyConfirmation.flag));
  useEffect(() => {
    if (getServiceRequestedQty !== null && match.params.pr_id !== null)
      (async () => {
        setPrNo(match.params.pr_id);
        setVendorId(match.params.vendor_id);
        setIsLoading(true);
        await getServiceRequestedQty(match.params.pr_id);
        await getServiceQuantityConfirmation(match.params.pr_id,match.params.vendor_id);
        setIsLoading(false);
      })();
  }, [getServiceRequestedQty,match.params.pr_id]);

  useEffect(() => {
    if(servicesQty != null) {
      for(let i = 0; i < servicesQty.length; i++) {
        inputList.push({service_id:servicesQty[i]['service_id'],requested_qty:servicesQty[i]['requested_qty'],actual_qty: ''});
        setInputList(inputList); 
      }
    }
  },[servicesQty]);
  console.log(inputList);
  const handleActualQty = (index,key,value) => {
    const list = [...inputList];
    list[index][key] = value; 
    setInputList(list);
  }

  const handleSubmit = () => {
    const request = {
      'pr_no' : prNo,
      'vendor_id' : vendorId,
      'data' : inputList
    };
    //console.log(JSON.stringify(request));
    (async () => {
      setIsLoading(true);
      const res = await saveServiceQuanity(request);
      setIsLoading(false);
      if (res) {
        if(res == true) {
          console.log('Saved');  
          toast.success('PR confirmation save successfully.');             
          history.push(`${baseUrl}/service-pr-list`);           
        } else {
          toast.error('Something went wrong.');
        }
      }
  })(); 
  }

  const headerBtns = () => {
    return (
      <Fragment>
        {/* <Button
          onClick={filterToggle}
          className="filter-hamburger show-btn btn btn-transparent"
        >
          {' '}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button> */}
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.prConfirmation}
      Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
      linkUrl={`${baseUrl}/service-pr-list`}
    >
    {servicesQtyConfirmation && servicesQtyConfirmation?.data?.length > 0 ? (
     <>
     {servicesQtyConfirmation?.data.map((data,indexValue) => {
      return (
      <ConfirmationItration
       keyValue={indexValue}
       data={data}
       filesData={servicesQtyConfirmation?.vendorUpdateData[indexValue]}
      />
      )
     })}
     </>
    ):null} 
    {servicesQtyConfirmation && servicesQtyConfirmation.flag == 1 ? (
     <> 
    <CardSection title={localization.services} servClass={'serviceCss'}>   
    <div className='row' style={{'align-items':'baseline'}}>
      {servicesQty && servicesQty.length > 0 && servicesQty.map((item,index) => {
        return (
        <>
        <div className="col-md-6 col-sm-12">
        <span><b>{item.service_name}</b></span>
        </div>
        <div className="col-md-3 col-sm-12">
          <ConstantInput
              name="Requested Quantity"
              label={localization.requestedQty}
              type="text"
              value={item.requested_qty}
              disabled={true}
          />
        </div>
        <div className="col-md-3 col-sm-12">
          <ConstantInput
              name="subject"
              label={localization.actualQty}
              type="text"
              handleChange={(val) => {
                handleActualQty(index, 'actual_qty', val)
              }}
          />
        </div>
        </>
        )
      })}
    </div> 
    </CardSection>
    <div className="form-group col-10">
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => {
          handleSubmit();
        }}
      >
        {'Submit'}
      </button>
    </div>
    </>
    ):null}
    </Layout>
  );
};
export default PrConfirmation;
